export const getQueryParamsFromObject = (obj) => {
  const queryString = Object.keys(obj)
    .filter((key) => obj[key])
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join("&");

  return queryString ? `?${queryString}` : "";
};
